import { forwardRef } from 'react'
import { cn } from '../../utils'

type Props = React.ComponentProps<'textarea'> & {
  label?: string
}

const ElementCommentArea = forwardRef<
  HTMLTextAreaElement,
  Props
>(({ className, label, ...props }, ref) => {
  return (
    <div className="my-6 flex flex-col gap-2">
      <label className="text-[var(--theme-title-color)]">
        {label || 'その他 (説明)'}
      </label>
      <textarea
        className={cn(
          'h-[100px] w-full rounded-md border p-3 outline-1 focus:outline-[var(--theme-outline-color)] text-[var(--theme-title-color)]',
          className,
        )}
        ref={ref}
        {...props}
      />
    </div>
  )
})
ElementCommentArea.displayName = 'ElementCommentArea'

export { ElementCommentArea }
